"use client";

import {cartAtom} from "@/app/_jotaiAtoms/cartAtom";
import {useAtomValue} from "jotai";

const CartActiveIcon: React.FC = () => {
	const {cart: cartData} = useAtomValue(cartAtom);

	if (!cartData || !cartData.cartItems || cartData.cartItems.length === 0) {
		return;
	}

	return (
		<div className="absolute h-2 w-2 -translate-y-[0.35rem] translate-x-[0.55rem] rounded-full border border-white bg-orange-700 bg-clip-content transition-colors hover:border-gray-200 group-hover:border-gray-200" />
	);
};

export default CartActiveIcon;
